import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { CaseNameType, CaseRarity, CaseSubname, CaseType } from '@/entities/cases'
import { useEffect, useState } from 'react'
import { useStyles } from './styles'

export const CaseSubNameText = ({ caseName, styles }: { caseName: CaseNameType; styles?: React.CSSProperties }) => {
  const userLang = useUnit($userLanguage)
  const { classes } = useStyles()
  const [caseSubname, setCaseSubname] = useState({
    type: '',
    timeLimitation: '',
    rarity: '',
  })
  const subnameData = CaseSubname[caseName]
  const rarityData = CaseRarity[caseName]

  const type = subnameData
  const rarity = rarityData

  useEffect(() => {
    if (userLang) {
      setCaseSubname({
        type: CaseType[caseName][userLang],
        timeLimitation: '',
        rarity: CaseRarity[caseName][userLang],
      })
    }
  }, [userLang, caseName, rarity, type])
  if (!caseName) return <span></span>

  return (
    <div className={classes.root} style={styles}>
        <span className={classes.type} data-type={type?.en || ''}>
          {caseSubname.type}
        </span>,
        <span className={classes.rarity} data-caserarity={rarity?.en || ''}>
          {caseSubname.rarity}
        </span>
    </div>
  )
}
